export default {
  Summary: "/tcs/csat-report/summary",
  CountByQuestion: "/tcs/csat-report/count-by-question",
};
